import { bandLabel, type ScoreBand } from '@kk/domain';

import { portalLanguage } from '@/copy/activeLanguage';
import { deck } from '@/copy/deck';

/**
 * **A BAND'S NAME AS THE PORTAL DRAWS IT.** The wire's value never changes; only what is drawn does. Under the new
 * Kredit Score (`PublicConfig.scoreEngineV2` open) the lowest band is "Starting" (brief 05; the guides' audit,
 * 15 Oct), so that "Building" names only a child's badge. Every other band, and every band before the switch opens, is
 * the glossary's name in the portal's language.
 */
export function bandName(band: ScoreBand, newScore: boolean): string {
  if (newScore && band === 'Building') return deck.o03.bandStarting;
  return bandLabel(band, portalLanguage());
}
